module.exports = __webpack_public_path__ + "d1a29c11eda7855c709427aeae5d0f73.png";